import { OrderJSON } from '@app/@shared/orderjson.model';

// A previously submitted order sent back for corrections; the user edits and resubmits it.
export function isIncompleteResubmission(order: OrderJSON | null | undefined): boolean {
  return String(order?.action ?? '').toLowerCase() === 'incomplete';
}
